// src/landing/LandingPage.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import NavBar         from '../components/NavBar';
import MainSection    from '../components/MainSection';
import ServiceSection from '../components/ServiceSection';
import HowSection     from '../components/HowSection';
import AboutSection   from '../components/AboutSection';
import GallerySection from '../components/GallerySection';
import ContactSection from '../components/ContactSection';
import FooterSection  from '../components/FooterSection';

import { db }          from '../../common/firebase';
import { doc, getDoc } from 'firebase/firestore/lite';

const MAP = {
  nav:      NavBar,
  main:     MainSection,
  service:  ServiceSection,
  how:      HowSection,
  about:    AboutSection,
  gallery:  GallerySection,
  contact:  ContactSection,
  footer:   FooterSection,
};

export default function LandingPage() {
  const location = useLocation();
  const [order, setOrder]     = useState([]);
  const [visible, setVisible] = useState([]);

  // Firestore에서 설정 불러오기
  useEffect(() => {
    (async () => {
      const keys = Object.keys(MAP);
      try {
        const snap = await getDoc(doc(db, 'config', 'settings'));
        const cfg  = snap.exists() ? snap.data() : {};
        setOrder(cfg.order             || keys);
        setVisible(cfg.visibleSections || keys);
      } catch {
        setOrder(keys);
        setVisible(keys);
      }
    })();
  }, []);

  // 해시 이동 처리 (order가 준비된 후에도 동작하도록 order 의존성 추가)
  useEffect(() => {
    const hash = location.hash;
    if (!hash || !order.length) return;
    const id = hash.slice(1);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, [location.pathname, location.hash, order]);

  if (!order.length) return null;

  return (
    <>
      {order
        .filter(key => visible.includes(key))
        .map(key => {
          const Section = MAP[key];
          if (key === 'nav' || key === 'footer') {
            return <Section key={key} />;
          }
          return (
            <div id={key} key={key}>
              <Section />
            </div>
          );
        })}
    </>
  );
}
